import { render, staticRenderFns } from "./menu-1.vue?vue&type=template&id=64132300&scoped=true&"
import script from "./menu-1.vue?vue&type=script&lang=js&"
export * from "./menu-1.vue?vue&type=script&lang=js&"
import style0 from "./menu-1.vue?vue&type=style&index=0&id=64132300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64132300",
  null
  
)

export default component.exports